export const constMessage = {
    finderCloakUser: 'keycloak social account linked successfully',
};
